<template>
  <div
    v-if="item != null"
    :draggable="isDraggable"
    v-on:drag="onDrag"
    v-on:dragover="onDrag"
    v-on:dragstart="onDragStart"
    v-on:dragend="onDragEnd">
    <div
      class="list-card list-group-item"
      :class="{ 'with-dropdown': hasDropDown }"
    >
      <div 
        :class="
          `item-bar${item.colorCode === '#FFFFFF' ? ' item-bar--border' : ''}`
        "
        :style="{ backgroundColor: item.colorCode }"
      >
      </div>
      <div class="col-md-6 item-desc">
        <button v-if="hasDropDown" class="item-list-card-dropdown-toggle" @click="toggleDropdown">
          <i class="fa" :class="isDropdownOpen ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
        </button>
        <slot name="Decorator"></slot>
        <slot name="Content">
          <div>
            <router-link
              v-if="href != null"
              tag="a"
              :to="href"
              class="list-card-title"
            >
              {{ item.name }}
            </router-link>
            <div v-else :class="`name${noDate ? ' name--nospace' : ''}`">
              {{ item.name }}
            </div>
            <div v-if="!noDate" class="date">
              {{ Translations.labels.createdOn }} {{ item.creationDate }}
            </div>
          </div>
        </slot>
      </div>

      <div class="col-md-6 more-desc">
        <div class="stats">
          <slot name="QuickStats">
            <div>
              <span class="stats-value">0</span>
              <i class="far fa-dot-circle"></i>
            </div>
            <div>
              <span class="stats-value">0</span>
              <span></span><i class="fas fa-boxes"></i>
            </div>
            <div>
              <span class="stats-value">0</span>
              <i class="far fa-comment"></i>
            </div>
            <div>
              <span class="stats-value">0</span>
              <i class="fas fa-music"></i>
            </div>
            <div></div>
            <div>
              <span class="stats-value">0</span>
              <i class="fas fa-battery-half"></i>
            </div>
            <div>
              <span class="stats-value">0</span>
              <i class="far fa-grin"></i>
            </div>
          </slot>
          <div></div>
        </div>
        <div class="menu">
          <slot name="Menu"> </slot>
        </div>
      </div>
    </div>
    <div v-if="hasDropDown && isDropdownOpen" class="list-card-dropdown">
      <slot name="DropDown"></slot>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Translations from '@/store/translations';
import EventBus from '@/eventbus';
export default {
  name: 'ClockItemListCard',
  props: {
    item: Object,
    href: Object,
    noDate: Boolean,
    isDraggable: Boolean,
    open: Boolean,
    syncDropDown: Boolean, // True = emits a `toggle` event that should change the `open` prop; False = manage state locally
  },
  computed: {
    hasDropDown: function () {
      return Object.keys(this.$slots).includes('DropDown')
    },
    Translations: function() {
      return Translations;
    },
  },
  data() {
    return {
      clientX: 0,
      clientY: 0,
      isDropdownOpen: false
    };
  },
  methods: {
    onDrag(e) {
      const { clientY, clientX } = e;

      if (clientY === this.clientY && clientX === this.clientX) {
        return;
      }

      this.clientX = clientX;
      this.clientY = clientY;
      EventBus.$emit('drag', e);
    },
    onDragStart(e) {
      // Fix for Firefox
      e.dataTransfer.setData('text', 'drag');
      e.currentTarget.classList.add('is-dragged');
      EventBus.$emit('dragStart', e, this.item);
    },
    onDragEnd(e) {
      e.currentTarget.classList.remove('is-dragged');
      EventBus.$emit('dragEnd', e);
    },
    toggleDropdown() {
      if (this.syncDropDown) {
        this.$emit('toggle', this.isDropdownOpen)
      } else {
        this.isDropdownOpen = !this.isDropdownOpen
      }
    }
  },
  watch: {
    open: {
      handler: function (value) {
        this.isDropdownOpen = value
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
    //-----------------------------------------------
    // Specific display for clock-boxes
    //-----------------------------------------------
    .clock-detail .list-cards .list-card{
        padding :0 0;
        .name{
          margin:0;
          font-size: 12px;
          user-select: none;
        }
    }
    //-----------------------------------------------
.list-card {
  font-weight: 400;

  &.with-dropdown {
    padding-left: 0;
  }

  .item-desc {
    .list-card-title {
      transition: color 0.2s ease-in-out;
      color: #292c33;
      font-size: 15px;
      font-weight: 600;
      line-height: calc(18 / 15);
    }

    .name--nospace {
      margin-bottom: 0;
    }
  }

  .date {
    color: #abacaf;
    font-size: 13px;
    letter-spacing: 0.2px;
    line-height: calc(16 / 13);
    margin-top: 6px;
  }

  .stats-value {
    display: block;
    opacity: 0.8;
    color: #292c33;
    font-size: 13px;
    font-weight: 400;
    line-height: 1;
    text-align: center;
    margin-bottom: 5px;

    small {
      // font-size: 8px;
      vertical-align: baseline;
    }
  }
}
</style>

<style lang="scss">
.list-card {
  padding-right: 0;
  cursor: pointer;
  .menu {
    .btn.btn-secondary {
      border: 0;
      background: none;

      i {
        transition: color 0.2s ease-in-out;
        font-size: 18px;
        // opacity: .4;
      }

      &:after {
        content: none;
      }

      &:focus,
      &:hover {
        background: transparent;
      }
    }
  }
}
.item-list-card-dropdown-toggle {
  background: none;
  border: none;
  color: #8c8c8c;

  &:hover {
    color: #212529;
  }

  &:focus {
    outline: none
  }
}
</style>
